module.exports = __webpack_public_path__ + "static/media/firefox.c8eb685c.png";